import React from "react";
import styled from "styled-components";
import { Popover, Tooltip } from "antd";
import { FiAlertCircle } from "@react-icons/all-files/fi/FiAlertCircle";
import { FiEdit3 } from "@react-icons/all-files/fi/FiEdit3";
import { IBrand } from "../../../../Models/IBrand";
import { Header, HeaderFocus } from "../Styled/RetailMatchIntroStyles";

interface RetailMatchIntroTextHeaderProps {
  address: string;
  isSharing: boolean;
  multiBrand: boolean;
  sampleCount: number;
  brandName: string;
  brand: IBrand;
  backDateVerbiage: string;
  showEditAddressModal: () => void;
  marginBottom?: string;
}

const IntroSummaryDiv = styled.div`
  font-size: 13px;
  text-align: center;
`;

const RetailMatchIntroTextHeader = ({
    address,
    isSharing,
    showEditAddressModal,
    multiBrand,
    sampleCount,
    brandName,
    brand,
    backDateVerbiage,
    marginBottom,
}: RetailMatchIntroTextHeaderProps) => {
    const style = marginBottom ? { marginBottom } : null;
    return (
    // Create the HTML, via Typescript, for the retail match report text header.  This is the
    // section containing the physical address, the edit address button, and similar brand text.
        <Header style={style}>
            <HeaderFocus>
                {/*
         * BUG 12370:
         * https://dev.azure.com/buxtonco/BUXTON_ANALYTICS_PLATFORM/_workitems/edit/12370
         * There is a very odd bug regarding the difference between the site itself and the
         * generated PDF if someone wants to print the report.  The PDF will wrap the
         * zipcode overlapping with other text and it gets hard to read.  Not wrapping the
         * text makes the site unable to display without the values going off screen.
         * The compromise between the two parts, after much testing, was to hardcode the
         * width to the current size of the parent container, which is 670, and force the
         * span to behave as a block element.  It appears that the PDF generator doesn't
         * respect auto scaling from the parent containers, for whatever reason, hence the
         * hardcoded value.
         * Credit to Hunter Gemmer for help with this fix.
         */}
                <span style={{ whiteSpace: "normal", display: "block", width: 670 }}>
                    {address}
                </span>
                {!isSharing && (
                    <Popover content="Edit Address">
                        <FiEdit3
                            onClick={showEditAddressModal}
                            style={{
                                position: "relative",
                                top: "3px",
                                marginLeft: "0.5em",
                                cursor: "pointer",
                            }}
                        />
                    </Popover>
                )}
            </HeaderFocus>
            <div style={{ fontSize: 20, letterSpacing: "1.3px" }}>COMPARED TO</div>
            {!multiBrand && brand && (
                <HeaderFocus>
                    {sampleCount.toLocaleString()} Existing Similar {brandName} Locations
                </HeaderFocus>
            )}
            <IntroSummaryDiv>
                {multiBrand && "Existing similar locations of the following brands "}
        based on analysis of consumer mobile device signals {backDateVerbiage}.
            </IntroSummaryDiv>
            <IntroSummaryDiv>
                {multiBrand && !isSharing && (
                    <>
                        {
                            "Click a brand in the table below to view a detailed analysis for that brand."
                        }
                        <Tooltip
                            placement="bottom"
                            title={
                                "Exporting to Loopnet or Crexi or Printing will include up to the top 5 brands in the table of results."
                            }
                        >
                            <FiAlertCircle
                                size={16}
                                style={{ verticalAlign: "middle", marginLeft: "5px" }}
                            />
                        </Tooltip>
                    </>
                )}
            </IntroSummaryDiv>
        </Header>
    );
};

export default React.memo(RetailMatchIntroTextHeader);
